import { render, staticRenderFns } from "./MY24BMWi7-disclosure.vue?vue&type=template&id=f2939ada&"
import script from "./MY24BMWi7-disclosure.vue?vue&type=script&lang=js&"
export * from "./MY24BMWi7-disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports